// extracted by mini-css-extract-plugin
export default {"FreeformTextarea":"FreeformTextareaEditor_FreeformTextarea__WQfAb"};